(function () {
  var STORAGE_KEY = "resorse_sale_countdown_end";
  var MIN_MINUTES = 30;
  var MAX_MINUTES = 3 * 60;

  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function randomTotalMinutes() {
    return MIN_MINUTES + Math.floor(Math.random() * (MAX_MINUTES - MIN_MINUTES + 1));
  }

  function ensureEndTime() {
    var stored = sessionStorage.getItem(STORAGE_KEY);
    var end = stored ? parseInt(stored, 10) : 0;
    if (!end || end <= Date.now()) {
      end = Date.now() + randomTotalMinutes() * 60 * 1000;
      sessionStorage.setItem(STORAGE_KEY, String(end));
    }
    return end;
  }

  function tick(el) {
    var end = el.dataset.acEnd ? Date.parse(el.dataset.acEnd) : ensureEndTime();
    if (el.dataset.acEnd && (!Number.isFinite(end) || end <= Date.now())) {
      el.hidden = true;
      return false;
    }
    var sec = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var d = Math.floor(sec / 86400);
    sec %= 86400;
    var h = Math.floor(sec / 3600);
    var m = Math.floor((sec % 3600) / 60);
    var s = sec % 60;
    var dEl = el.querySelector("[data-ac-days]");
    var hEl = el.querySelector("[data-ac-hours]");
    var mEl = el.querySelector("[data-ac-minutes]");
    var sEl = el.querySelector("[data-ac-seconds]");
    if (dEl) dEl.textContent = pad2(d);
    if (hEl) hEl.textContent = pad2(h);
    if (mEl) mEl.textContent = pad2(m);
    if (sEl) sEl.textContent = pad2(s);
    return true;
  }

  function init(el) {
    if (el.dataset.acInit) return;
    el.dataset.acInit = "1";
    if (tick(el)) {
      var interval = setInterval(function () {
        if (!tick(el)) clearInterval(interval);
      }, 1000);
    }
  }

  function initAll() {
    document.querySelectorAll("[data-announcement-countdown]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
